module.exports = __webpack_public_path__ + "static/media/4th_banner.000ab946.png";